<template>
  <div>
    {{ t('wxLogin.logging_in') }}
  </div>
</template>

<script>

import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router/dist/vue-router";
import { useI18n } from 'vue-i18n';
import { wxLogin } from "@/api/api";
import router from "@/router";
import { ElMessage } from "element-plus";

export default {
  name: 'callBackWx',
  components: {
  },

  setup() {
    const { t } = useI18n();
    const route = useRoute();
    onMounted(() => {
      console.log('微信登录，开始登录')
      //微信登录，获取 url 的 token 并调用接口登录
      const code = route.query.code
      console.log('微信登录，获取到了code', code)
      if (code) {
        wxLogin({ code }).then(res => {
          localStorage.setItem('token', res.accessToken)
          console.log('获取到 token', res.accessToken)

          // 检测是否为Safari浏览器
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
          console.log('是否为Safari浏览器:', isSafari)

          // if (isSafari) {
          //   // Safari浏览器特殊处理：使用window.location直接跳转到首页
          //   console.log('Safari浏览器：使用window.location跳转到首页')
          //   window.location.href = '/?loginType=1'
          // } else {
          //   // 其他浏览器使用正常的返回逻辑
          //   console.log('其他浏览器：返回上一页')
          //   // router.go(-1)
          // }
          window.location.href = '/?loginType=1'
        }).catch(res => {
          console.error('微信登录失败:', res)
          ElMessage.error(t('wxLogin.login_failed'))
          router.go(-1)
        })
      }
    })
    // watch(() => route.query.code,
    //     (newCode) => {
    //       if (newCode) {
    //         console.log('newCode')
    //         wxLogin({ code: newCode }).then(res => {
    //           localStorage.setItem('token',res.accessToken)
    //           router.go(-1)
    //         }).catch(res => {});
    //       }
    //     })

    return {
      t
    }
  }
}

</script>
<style scoped></style>
